<!--
 @description tab导航
 @author xiehan
 @date 2018/9/19
-->
<style>
  .app-tab .el-tabs__header {
    margin: 0;
  }
</style>
<template>
  <div class="app-tab">
    <el-tabs v-model="activeName" 
      type="card" 
      @tab-click="selectTab" 
      @tab-remove="removeTab"
      closable>
      <el-tab-pane 
        v-for="item in tabList"
        :key="item.code"
        :label="item.name"
        :name="item.code">
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      activeName: ''
    }
  },
  computed: {
    tabList () {
      return this.$store.state.tabModule.tabList
    },
    activeTab () {
      return this.$store.state.tabModule.activeTab
    },
    defaultActiveMenu () {
      return this.$store.state.menuModule.defaultActiveMenu
    }
  },
  methods: {
    selectTab (val) {
      let selectInfo = this.$store.getters.findTabByName(val.label)
      let tabIndex = this.$store.getters.findTabIndexByCode(val.label)
      this.$store.commit('setActiveMenu', selectInfo.code)
      this.$router.push({ path: selectInfo.fullPath })
      if (tabIndex >= 0) {
        this.$store.commit('setActiveMenu', this.$route.name)
      } else {
        this.$store.commit('setActiveMenu', this.$route.path.split('/')[2])
      }
      this.$nextTick(this.setMenuScrollTop)
    },
    removeTab (code) {
      this.$store.commit('removeTab', code)
      let fullPath = this.tabList[this.$store.getters.findTabIndexByCode(this.activeTab)].fullPath
      if (fullPath) {
        this.$router.push({ path: fullPath })
        this.$nextTick(this.setMenuScrollTop)
      }
    },
    setMenuScrollTop () {
      const scorllBox = document.getElementsByTagName('aside')[0]
      const markLi = document.getElementsByClassName('is-active')[0] ? document.getElementsByClassName('is-active')[0] : ''
      if (markLi) {
        scorllBox.scrollTop = markLi.offsetTop
      }
    }
  },
  watch: {
    activeTab (val) {
      this.activeName = val
      this.$store.commit('setActiveMenu', val)
    },
    defaultActiveMenu () {
      this.activeName = this.$store.state.tabModule.activeTab
    },
    $route (val) {
      let tabIndex = this.$store.getters.findTabIndexByCode(val.name)
      if (tabIndex >= 0) {
        this.$store.commit('setFullPath', {
          code: this.tabList[tabIndex].code,
          fullPath: val.fullPath
        })
      } else {
        tabIndex = this.$store.getters.findTabIndexByCode(val.path.split('/')[2])
        this.$store.commit('setFullPath', {
          code: this.tabList[tabIndex].code,
          fullPath: val.fullPath
        })
      }
      this.$store.commit('setActiveTab', this.tabList[tabIndex].code)
      this.$store.commit('setActiveMenu', this.tabList[tabIndex].code)
    }
  },
  mounted () {

  }
}
</script>